import React from 'react';
import './Illustrations.css';

const FLAME_PATH =
  'M0 -40 C14 -22 26 -12 26 6 C26 24 14 36 0 36 C-14 36 -26 24 -26 6 C-26 -4 -20 -12 -14 -18 C-12 -8 -6 -6 -4 -10 C-2 -20 -6 -30 0 -40 Z';
const FLAME_CORE_PATH = 'M0 -4 C8 6 12 12 12 20 C12 29 6 34 0 34 C-6 34 -12 29 -12 20 C-12 12 -6 6 0 -4 Z';
// To-do rows on the front sheet: y position and how long the text line is
const ROWS = [
  { y: 82, width: 80 },
  { y: 116, width: 62 },
  { y: 150, width: 84 },
  { y: 184, width: 54 },
];

/**
 * "Alt annet brenner": a pile of to-do lists catching fire, with a clock ticking next to it.
 * Used on the "Om oss" page beside why we started Revetall.
 * @returns {JSX.Element} Decorative drawing
 */
function BusyIllustration() {
  return (
    <svg className="illustration" viewBox="0 0 320 260" aria-hidden="true" focusable="false">
      <ellipse className="ill-shadow" cx="160" cy="244" rx="112" ry="9" />

      {/* Two sheets behind, slightly turned */}
      <rect className="ill-paper" x="70" y="44" width="150" height="182" rx="12" transform="rotate(-9 145 135)" />
      <rect className="ill-paper" x="100" y="42" width="150" height="182" rx="12" transform="rotate(7 175 133)" />

      {/* Front sheet: a to-do list where only the first item is done */}
      <rect className="ill-paper" x="84" y="48" width="150" height="182" rx="12" />
      {ROWS.map((row) => (
        <g key={row.y}>
          <rect className="ill-line-navy" x="104" y={row.y - 9} width="18" height="18" rx="5" />
          <rect className="ill-line" x="134" y={row.y - 4} width={row.width} height="8" rx="4" />
        </g>
      ))}
      <path className="ill-line-orange" d="M108 82 L112 87 L119 77" />

      {/* Flames on the pile */}
      <g transform="translate(238 66)">
        <path className="ill-orange" d={FLAME_PATH} />
        <path className="ill-gold" d={FLAME_CORE_PATH} />
      </g>
      <g transform="translate(252 204) scale(0.55)">
        <path className="ill-orange" d={FLAME_PATH} />
        <path className="ill-gold" d={FLAME_CORE_PATH} />
      </g>
      <path className="ill-line-gold" d="M276 40 L284 32 M282 62 L292 60 M262 22 L264 12" />

      {/* Clock */}
      <circle className="ill-white" cx="72" cy="198" r="30" />
      <circle className="ill-line-navy" cx="72" cy="198" r="30" />
      <path className="ill-line-navy" d="M72 198 L72 180 M72 198 L85 205" />
    </svg>
  );
}

export default BusyIllustration;
